import { Capacitor } from '@capacitor/core';
import { clearAuthSession } from '@shared/auth/session';
import { unregisterCurrentPushToken } from '../../hooks/useProPushNotifications';

/** Tear down the Pro session and route to the appropriate login screen. */
export async function proSignOut(): Promise<void> {
  await unregisterCurrentPushToken();
  clearAuthSession({ clearAccountType: true });
  window.location.href = Capacitor.isNativePlatform() ? '/pro/login' : '/login';
}
